<script lang="ts">
	import type { NavigationInfo } from "$lib/state/models/navigation-info.svelte";

	interface Props {
		prevLink: NavigationInfo | null;
		nextLink: NavigationInfo | null;
	}

	const { prevLink, nextLink }: Props = $props();
</script>

<div class="flex">
	{#if prevLink}
		<div class="flex flex-col items-start gap-3">
			<a
				class="inline-flex justify-center gap-0.5 overflow-hidden rounded-full bg-zinc-100 px-3 py-1 text-sm font-medium text-zinc-900 transition hover:bg-zinc-200 dark:bg-zinc-800/40 dark:text-zinc-400 dark:ring-1 dark:ring-zinc-800 dark:ring-inset dark:hover:bg-zinc-800 dark:hover:text-zinc-300"
				aria-label="Předchozí: {prevLink.title}"
				href={`${prevLink.path}/`}>
				<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" class="-ml-1 h-5 w-5 rotate-180">
					<path
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						d="m11.5 6.5 3 3.5m0 0-3 3.5m3-3.5h-9">
					</path>
				</svg>
				Předchozí
			</a>
			<a
				tabindex="-1"
				aria-hidden="true"
				class="text-base font-semibold text-zinc-900 transition hover:text-zinc-600 dark:text-white dark:hover:text-zinc-300"
				href={`${prevLink.path}/`}>{prevLink.title}</a>
		</div>
	{/if}
	{#if nextLink}
		<div class="ml-auto flex flex-col items-end gap-3">
			<a
				class="inline-flex justify-center gap-0.5 overflow-hidden rounded-full bg-zinc-100 px-3 py-1 text-sm font-medium text-zinc-900 transition hover:bg-zinc-200 dark:bg-zinc-800/40 dark:text-zinc-400 dark:ring-1 dark:ring-zinc-800 dark:ring-inset dark:hover:bg-zinc-800 dark:hover:text-zinc-300"
				aria-label="Následující: {nextLink.title}"
				href={`${nextLink.path}/`}>
				Následující
				<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" class="-mr-1 h-5 w-5">
					<path
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						d="m11.5 6.5 3 3.5m0 0-3 3.5m3-3.5h-9">
					</path>
				</svg>
			</a>
			<a
				tabindex="-1"
				aria-hidden="true"
				class="text-right text-base font-semibold text-zinc-900 transition hover:text-zinc-600 dark:text-white dark:hover:text-zinc-300"
				href={`${nextLink.path}/`}>{nextLink.title}</a>
		</div>
	{/if}
</div>
